<template>
    <div class="credit-card">
        <div class="container">
            <div class="header">
                <div class="title">{{ $t("message.cardInfos") }}</div>
                <div class="sub-title">
                    {{ $t("message.saveSystemCardInfo") }}
                </div>
            </div>
            <div v-if="!newCardForm && billingDetail && billingDetail.binNumber">
                <div class="bill">
                    <div style="display: flex; align-items: center; justify-content: space-between; width: 100%">
                        <div style="display: flex; align-items: top">
                            <div class="payment-method">
                                <DynamicSvg :name="formatCardType(billingDetail.cardAssociation)" />
                            </div>
                            <div>
                                <div style="font-weight: bold">
                                    {{ formatCardNumber(billingDetail.binNumber) }}
                                </div>
                                <div style="color: rgb(160, 160, 160)">
                                    {{ formatCardType(billingDetail.cardAssociation) }}
                                </div>
                            </div>
                        </div>
                        <div @click="newCardForm = true" class="add-card-button">
                            <span class="material-icons" style="font-size: 16px; margin-right: 5px"> edit </span>
                            Yeni Kart Ekle
                        </div>
                    </div>
                </div>
                <div class="user-agreement">
                    <input type="checkbox" v-model="userAgreement" />
                    <label @click="() => (userAgreementModal = true)">{{
                        $t("message.confidentialityAgreementCheck")
                    }}</label>
                </div>
            </div>
            <div v-else>
                <div class="form">
                    <InputComp
                        v-model="name"
                        placeHolder="Hakan Kaya"
                        size="large"
                        :title="$t('message.cardNameSurname')"
                    />
                    <div class="creditCard">
                        <div class="number">
                            <InputComp
                                mask="creditCard"
                                color="#ec4b1d"
                                v-model="cardNumber"
                                size="large"
                                placeHolder="0000 0000 0000 0000"
                                :title="$t('message.cardNumber')"
                            />
                            <div v-if="type !== null" class="logo">
                                <DynamicSvg :name="type" />
                            </div>
                        </div>
                        <InputComp mask="cvv" placeHolder="000" type="text" v-model="cvv" size="small" :title="'CVV'" />
                        <InputComp
                            mask="skt"
                            placeHolder="01/22"
                            type="text"
                            v-model="skt"
                            size="small"
                            :title="$t('message.skt')"
                        />
                    </div>
                    <div
                        v-if="billingDetail && billingDetail.binNumber"
                        @click="newCardForm = false"
                        class="add-card-button"
                    >
                        Mevcut Kart Kullan
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import InputComp from "../../Input.vue";
import creditCardType from "credit-card-type";
import { Modal } from "ant-design-vue";
// import { message } from "ant-design-vue";
import DynamicSvg from "../../DynamicSvg.vue";
import { mapState } from "vuex";

export default {
    name: "CreditCardForm",
    data() {
        return {
            userAgreementModal: false,
            userAgreement: false,
            name: "",
            cardNumber: "",
            type: "Visa",
            skt: "",
            newCardForm: true,
            cvv: null,
        };
    },
    computed: {
        ...mapState({
            billingDetail: (state) => state.site.billingDetail,
        }),
    },
    mounted() {
        if (this.billingDetail && this.billingDetail.binNumber) {
            this.newCardForm = false;
        }
        this.emitHandler();
    },
    methods: {
        getCreditCardType(value) {
            this.cardNumber = value;
            const response = creditCardType(value);
            if (response.length) {
                this.type = response[0].niceType;
            }
        },
        emitHandler() {
            this.$emit("input", {
                userAgreement: this.userAgreement,
                name: this.name,
                cardNumber: this.cardNumber,
                type: this.type,
                skt: this.skt,
                cvv: this.cvv,
                newCardForm: this.newCardForm,
            });
        },
        formatCardNumber(binNumber) {
            return binNumber.padEnd(16, "•");
        },
        formatCardType(type) {
            type = type.split("_").join("");
            return type[0].toUpperCase() + type.slice(1).toLowerCase();
        },
    },
    watch: {
        userAgreementModal() {
            if (this.userAgreementModal === true) {
                return (document.body.style.overflow = "scroll");
            }
            return (document.body.style.overflow = "auto");
        },
        newCardForm() {
            this.emitHandler();
        },
        name() {
            this.emitHandler();
        },
        skt() {
            this.emitHandler();
        },
        cardNumber() {
            this.getCreditCardType(this.cardNumber);
            this.emitHandler();
        },
        type() {
            this.emitHandler();
        },
        userAgreement() {
            this.emitHandler();
        },
        cvv() {
            this.emitHandler();
        },
    },
    components: { InputComp, Modal, DynamicSvg },
};
</script>
<style lang="scss">
.credit-card {
    width: 100%;

    .add-card-button {
        border: 1px solid rgb(236, 75, 29);
        color: rgb(236, 75, 29);
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 10px 15px;
        border-radius: 100px;
        user-select: none;
        cursor: pointer;
        margin-top: 10px;
    }

    .bill {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 20px 0px;

        .payment-method {
            width: 50px;
            height: 50px;
            margin-right: 10px;

            svg {
                width: 100%;
                height: 100%;
            }
        }
    }

    .container {
        padding: 36px 36px;
        border: 1px solid rgba(0, 0, 0, 0.125);
        border-radius: 10px;
        background-color: white;

        .header {
            margin-bottom: 24px;

            .title {
                font-size: 24px;
                color: #144167;
                font-weight: bold;
                margin-bottom: 15px;
            }

            .sub-title {
                color: #a5a5a5;
                font-size: 16px;
            }
        }

        .form {
            .creditCard {
                display: flex;
                align-items: center;
                gap: 10px;
                .number {
                    position: relative;
                    display: flex;
                    align-items: center;
                    width: 100%;

                    .logo {
                        position: absolute;
                        right: 10px;
                        width: 50px;
                        height: 50px;

                        svg {
                            width: 100%;
                            height: 100%;
                        }
                    }
                }
            }

            #input {
                .title {
                    label {
                        color: #536777;
                        font-size: 14px;
                        font-weight: bold;
                        margin-top: 0;
                    }
                }

                .input-container {
                    padding: 10px 5px;
                    height: auto;

                    input {
                        font-size: 14px;
                    }
                }
            }

            .credit-button {
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                background-color: #ec4b1d;
                border-radius: 7px;
                color: white;
                padding: 14px 0px;
                font-size: 18px;
                cursor: pointer;
                user-select: none;
                font-weight: 700;
                margin-top: 20px;
            }
        }

        .user-agreement {
            display: flex;
            align-items: center;
            margin: 10px 0px;

            input {
                accent-color: #ec4b1d;
                width: 20px;
                height: 20px;
            }

            label {
                margin: 0;
                padding: 0;
                margin-left: 10px;
                cursor: pointer;
                text-decoration: underline;
            }
        }
    }
}
</style>
